var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase, @typescript-eslint/naming-convention */
// Training Mode (ipa-training-mode)
// Prompt-coach client: sends a draft message to the orchestrator for CARE-rubric
// analysis BEFORE the message goes to the assistant. Fail-open by design — any
// error resolves to a "good" verdict so coaching can never block a send.
// The orchestrator loads recent conversation turns server-side from
// conversation_id; the widget never sends the transcript.
import orchestratorApiClient from './orchestrator-api-client';
import { serializePageContext } from './chatApi';
const FAIL_OPEN_RESULT = {
    verdict: 'good',
    issues: [],
    improved_prompt: null,
    why: null
};
const COACH_CLIENT_TIMEOUT_MS = 10000;
export function requestCoaching(draft, pageContext, conversationId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const { data } = yield orchestratorApiClient.post('/chat/coach', {
                draft,
                page_context: pageContext ? serializePageContext(pageContext) : null,
                conversation_id: conversationId !== null && conversationId !== void 0 ? conversationId : null
            }, { timeout: COACH_CLIENT_TIMEOUT_MS });
            if (data && (data.verdict === 'good' || data.verdict === 'improvable')) {
                return Object.assign(Object.assign(Object.assign({}, FAIL_OPEN_RESULT), data), { issues: Array.isArray(data.issues) ? data.issues : [] });
            }
            return FAIL_OPEN_RESULT;
        }
        catch (err) {
            if (process.env.NODE_ENV !== 'production') {
                console.warn('[AIChatWidget] Coach request failed; failing open:', err);
            }
            return FAIL_OPEN_RESULT;
        }
    });
}
